export const locksConstants = {
  LOCK: 'LOCK',
  UNLOCK: 'UNLOCK',
}
